export const fmtPostal = (value) => {
    const digits = String(value || '')
        .replace(/\D+/g, '')
        .slice(0, 5);

    return digits.length <= 2
        ? digits
        : `${digits.slice(0, 2)}-${digits.slice(2)}`;
};
